/**
 * Grid Collection Mapper
 *
 * Maps collection names to their Redux state selectors.
 * Used by StandardDataGrid to automatically read data from the correct Redux slice.
 */

import { COLLECTION_EMPLOYEES } from '../constants/collections'
import {
  getEmployeesFromCollection,
  getVisibleColumns as getEmployeeVisibleColumns
} from '../selectors/employeeSelectors'
import {
  getParams,
  getTotal,
  isLoading
} from '../selectors/collectionSelectors'

/**
 * Map of collection names to their collection constants
 */
const COLLECTION_CONSTANTS = {
  employees: COLLECTION_EMPLOYEES,
  // allowances: COLLECTION_ALLOWANCES,
  // Add other collections here
}

/**
 * Get collection constant for a collection name
 */
export const getCollectionConstant = (collectionName) => {
  const constant = COLLECTION_CONSTANTS[collectionName]
  if (!constant) {
    throw new Error(`No collection constant found for: ${collectionName}`)
  }
  return constant
}

/**
 * Get rows selector for a collection
 */
export const getRowsSelector = (collectionName) => {
  switch(collectionName) {
    case 'employees':
      return getEmployeesFromCollection
    // case 'allowances':
    //   return getAllowancesFromCollection
    default:
      throw new Error(`No rows selector found for collection: ${collectionName}`)
  }
}

/**
 * Get visible columns selector for a collection
 */
export const getVisibleColumnsSelector = (collectionName) => {
  switch(collectionName) {
    case 'employees':
      return getEmployeeVisibleColumns
    // case 'allowances':
    //   return getAllowanceVisibleColumns
    default:
      // Default: return all columns
      return () => []
  }
}

/**
 * Get params selector (generic for all collections)
 */
export const getParamsSelector = (collectionName) => {
  const collectionConstant = getCollectionConstant(collectionName)
  return (state) => getParams(state, collectionConstant)
}

/**
 * Get total selector (generic for all collections)
 */
export const getTotalSelector = (collectionName) => {
  const collectionConstant = getCollectionConstant(collectionName)
  return (state) => getTotal(state, collectionConstant)
}

/**
 * Get loading selector (generic for all collections)
 */
export const getLoadingSelector = (collectionName) => {
  const collectionConstant = getCollectionConstant(collectionName)
  return (state) => isLoading(state, collectionConstant)
}
